export default __webpack_public_path__ + "static/avatar-kayi-common-6-44ee3292e0b20d99580adeedc1aa2d0f.png";